import axiosInstance from '../../api/axiosInstance'
import { resolveShippingDestinationCityCode } from '../../utils/shippingDestinationCityCode'

export const cotizarConEnvia = async (formData: any, orderDetail: any, selectedTipoServicio: string) => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    throw new Error("Error de autenticación");
  }

  const configData = {
    cod_regional_cta: 3,
    cod_oficina_cta: 1, 
    codigo_cuenta: 5011,
    codigo_cuenta_recaudo: 5012,
    num_unidades: 1,
    codFormaPago: 4,
    ciudad_destin_ej: ''
  };

  const codigo_cuenta = formData.metodoPago === 'cod' ? configData.codigo_cuenta_recaudo : configData.codigo_cuenta;
  const valorProducto = formData.metodoPago === 'cod' ? parseInt(orderDetail?.total || "0") : 0;

  const ciudadDestino =
    configData.ciudad_destin_ej ||
    resolveShippingDestinationCityCode(orderDetail, formData) ||
    orderDetail?.shippingAddress?.city ||
    ''

  if (!ciudadDestino || !/^\d{5}$/.test(String(ciudadDestino))) {
    throw new Error(
      'Faltan datos requeridos para la liquidación: seleccione departamento y ciudad de destino'
    )
  }

  const cotizacionData = {
    ciudad_origen: '05001',
    ciudad_destino: String(ciudadDestino),
    cod_formapago: 4,
    cod_servicio: parseInt(selectedTipoServicio),
    cod_regional_cta: configData.cod_regional_cta,
    cod_oficina_cta: configData.cod_oficina_cta,
    cod_cuenta: codigo_cuenta,
    info_cubicacion: [{
      cantidad: 1,
      largo: Math.round(formData.largo),
      ancho: Math.round(formData.ancho),
      alto: Math.round(formData.altura),
      peso: formData.peso < 1 ? 1 : formData.peso,
      declarado: Math.round(formData.valorDeclarado || 0)
    }],
    mca_docinternacional: 0,
    con_cartaporte: "0",
    info_contenido: {
      num_documentos: orderDetail?.id?.toString() || "",
      valorproducto: valorProducto,
    }
  };

  try {
    console.log('📤 Enviando cotización a Envía:', cotizacionData);
    const response = await axiosInstance.post("/liquidacion/calcular", cotizacionData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    console.log('✅ Respuesta de Envía:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('❌ Error en cotización Envía:', error);
    
    // Proporcionar información específica del error
    if (error.response) {
      const status = error.response.status;
      const data = error.response.data;
      throw new Error(`Envía API Error (${status}): ${data?.message || data?.error || 'Error desconocido'}`);
    } else if (error.request) {
      throw new Error('Envía API: No se pudo conectar con el servidor');
    } else {
      throw new Error(`Envía API: ${error.message}`);
    }
  }
};
